// Centralized API configuration
// Uses relative URL for production (same-origin requests) 
// Falls back to env var for local development
export const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${API_BASE}/api`;
